import { addLog } from 'src/api/logger';

export const logEvent = async (eventType, details = {}) => {
  const userId = details.user_id;
  if (!userId) return;
  try {
    await addLog({
      user_id: userId,
      action_type: eventType,
      module_type: details.module_type,
      created_by: details.created_by,
      meta: details.meta,
    });
  } catch (err) {
    console.error('Failed to send log:', err);
  }
};
